import type { CSSProperties, FC } from 'react';
import { useMemo } from 'react';

import { useGetCurrentLegalTexts } from '@/features/api/hooks/shared-legal/useGetCurrentLegalTexts';
import type {
  AppNativeStackScreenProps,
  AppRoute
} from '@/navigation/types/navigation';
import { StateView } from '@/shared/components/state-view/StateView';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme): Record<string, CSSProperties> => ({
  webView: {
    backgroundColor: theme.colors.surfaceContainerLow,
    height: '100%',
    border: 'none'
  }
});

export type Props = AppNativeStackScreenProps<typeof AppRoute.LegalText>;

// Todo: use EmbeddedWebpage
export const LegalTextScreen: FC<Props> = ({ route }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  const { id } = route.params;
  const { data: legalTexts } = useGetCurrentLegalTexts();
  const urlText = legalTexts?.find((t) => t.id === id)?.urlText;

  return (
    <StateView asView backgroundColor={theme.colors.surfaceContainerLow}>
      <iframe title={id} src={urlText} style={styles.webView} />
    </StateView>
  );
};
